const dateTimeToDate = (dateTime: any) => {
  const date: string = dateTime?.split("T")[0];

  let year = date?.split("-")[0];
  let month = date?.split("-")[1];
  let day = date?.split("-")[2];

  const requiredDate: string = day + "-" + month + "-" + year;

  return requiredDate;
};

export function dateTimeToDateYYYYMMDD(dateTimeStr: string) {
  if (!dateTimeStr?.length) return;
  // Split the date and time
  let [dateStr, timeStr] = dateTimeStr.split(" ");

  // Split the date parts
  let [month, day, year] = dateStr.split("/");

  // Format the date as 'YYYY-MM-DD'
  let formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
    2,
    "0"
  )}`;

  return formattedDate;
}

export function formatTimestamp(timeString: string): string {
  const date = new Date(timeString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}`;
}

export default dateTimeToDate;
